export default __webpack_public_path__ + "c051f23d4c1e77faf908369bb9cf8e26.svg";